var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"mb-3"},[_c('b-row',[_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.addUser}},[_vm._v("User erstellen")])],1),_vm._v(" "),_c('UserTable'),_vm._v(" "),_c('UserEditSidebar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }